import { AppName, getAppName } from 'modules/utils/ConfigUtils';

export const NEW_APP_MESSAGE_1 = `My Health+`;

export const NEW_APP_MESSAGE_2_MOBILE = ` is now the `;
export const NEW_APP_MESSAGE_2_WEB = ` is now known as the `;

export const NEW_APP_MESSAGE_3_MOBILE = `${getAppName(AppName.base, '', AppName.suffix1)}.`;
export const NEW_APP_MESSAGE_3_WEB = `${getAppName(AppName.base)}`;
export const NEW_APP_MESSAGE_3B_WEB = ` ${getAppName(AppName.suffix4)}.`;

export const NEW_APP_MESSAGE_4 = `Learn More`;

export const LEARN_MORE_MESSAGE_1_MOBILE = `Welcome to ${getAppName(
  AppName.base,
  'the',
  AppName.suffix1
)}. Don't worry, you're in the right place. You've still got all the great tools to manage your health in one simple to navigate location. We've just simplified the name, look, and feel to match our new simplified brand.`;
export const LEARN_MORE_MESSAGE_1_WEB = `Welcome to ${getAppName(AppName.base)}'s ${getAppName(
  AppName.suffix4
)}. Don't worry, you're in the right place. You've still got all the great tools to manage your health in one simple to navigate location. We've just simplified the name, look, and feel to match our new simplified brand.`;

export const LEARN_MORE_MESSAGE_2_MOBILE = `Sign in to ${getAppName(
  AppName.base,
  'the',
  AppName.suffix1
)} with your existing My Health+ user name and password. After signing in, you'll be able to view your test results, message with your care team, schedule an appointment, access on-demand care, pay a bill, view and refill your current prescriptions, and so much more.`;
export const LEARN_MORE_MESSAGE_2_WEB = `Sign in to ${getAppName(AppName.base)}'s ${getAppName(
  AppName.suffix4
)} with your existing My Health+ user name and password. After signing in, you'll be able to view your test results, message with your care team, schedule an appointment, access on-demand care, pay a bill, view and refill your current prescriptions, and so much more.`;

export const LEARN_MORE_MESSAGE_3A = `Need assistance?`;
export const LEARN_MORE_MESSAGE_3B = ` Call us at `;
